"use strict";

import Page from "./AddPermit.jsx";

export const auth = true;
export const title = "i18n:permits.addPermit";
export const Component = Page;
